<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 24h-24v-2h1v-13c1.793-1.211 3.484-2.153 5.116-2.826.534 2.743 2.997 4.864 5.961 4.826 2.914-.037 5.314-2.167 5.814-4.855 1.636.675 3.324 1.627 5.109 2.855v13h1v2zm-14-1h4v-4h-4v4zm-5 0h4v-4h-4v4zm10 0h4v-4h-4v4zm-10-6h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-12-3h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-5-14c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m1 2h-2v2h-2v2h2v2h2v-2h2v-2h-2v-2z"/></svg>
</template>

<script setup lang="ts">

</script>
